import React from 'react';

// =============================================================================
// HeroDecoration
// -----------------------------------------------------------------------------
// The marketing hero's flowing data lines: two faint curves with a slow
// travelling light along each. Shared by the landing page and
// /ai-transformation so both heroes read as one site. Decorative only; the
// styles (`.landing-hero__deco-svg`, `.landing-hero__deco-flow`, the
// reduced-motion exemption) live in `landingHeroStyles`, which the host page
// injects.
// =============================================================================

export function HeroDecoration() {
  return (
    <svg className="landing-hero__deco-svg" viewBox="0 0 1440 900" fill="none" preserveAspectRatio="none" aria-hidden="true">
      <path d="M-100 180 C200 160, 500 320, 720 280 S1100 180, 1540 320" stroke="rgba(184,59,29,0.05)" strokeWidth="1.5" />
      <path d="M-50 550 C300 530, 600 650, 800 610 S1100 550, 1500 650" stroke="rgba(184,59,29,0.03)" strokeWidth="1" />
      <circle cx="180" cy="200" r="3" fill="rgba(184,59,29,0.06)" />
      <circle cx="720" cy="290" r="4" fill="rgba(184,59,29,0.04)" />
      <circle cx="1260" cy="310" r="3" fill="rgba(184,59,29,0.06)" />
      <circle cx="400" cy="610" r="3" fill="rgba(184,59,29,0.04)" />
      <circle cx="950" cy="590" r="4" fill="rgba(184,59,29,0.04)" />
      {/* Traveling light: a short bright dash sweeps along each curve so
          the LINE itself glows in places (instead of discrete dots), the
          way many modern landing pages animate hero lines. Subtle and
          slow. Hidden under prefers-reduced-motion via the deco-flow
          class. */}
      {[
        { d: 'M-100 180 C200 160, 500 320, 720 280 S1100 180, 1540 320', dur: '7s', begin: '0s' },
        { d: 'M-50 550 C300 530, 600 650, 800 610 S1100 550, 1500 650', dur: '9s', begin: '2.5s' },
      ].map((p, i) => (
        <path
          key={i}
          className="landing-hero__deco-flow"
          d={p.d}
          fill="none"
          stroke="rgba(184,59,29,0.22)"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeDasharray="60 2400"
          style={{ filter: 'drop-shadow(0 0 4px rgba(184,59,29,0.15))' }}
        >
          <animate attributeName="stroke-dashoffset" from="2460" to="0" dur={p.dur} begin={p.begin} repeatCount="indefinite" />
        </path>
      ))}
    </svg>
  );
}

export default HeroDecoration;
